import { render, staticRenderFns } from "./FilesSidebarSubname.vue?vue&type=template&id=7bd1e3c0"
import script from "./FilesSidebarSubname.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesSidebarSubname.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesSidebarSubname.vue?vue&type=style&index=0&id=7bd1e3c0&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports